var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.113,
    height: 12.135,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.613 8.836v1.676a1.117 1.117 0 0 1-1.218 1.117 11.057 11.057 0 0 1-4.822-1.715 10.9 10.9 0 0 1-3.352-3.352A11.057 11.057 0 0 1 .505 1.718 1.117 1.117 0 0 1 1.617.5h1.676a1.117 1.117 0 0 1 1.117.961 7.174 7.174 0 0 0 .391 1.57A1.117 1.117 0 0 1 4.55 4.21l-.71.71a8.939 8.939 0 0 0 3.353 3.352l.71-.71a1.117 1.117 0 0 1 1.179-.251 7.174 7.174 0 0 0 1.57.391 1.117 1.117 0 0 1 .961 1.134Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.9ec9e0229a741205a74d7648b6600141.svg";
export { ForwardRef as ReactComponent };